import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { Layout } from './components/Layout';
import './custom.css';
import { ThemeProvider } from './components/ThemeContext';
import './components/Global.css'; // Import global CSS

import '@fortawesome/fontawesome-free/css/all.min.css';
function App() {
    return (
        <ThemeProvider>
            <Layout>
                <Routes>
                    {AppRoutes.map((route, index) => {
                        const { element, ...rest } = route;
                        return <Route key={index} {...rest} element={element} />;
                    })}
                </Routes>
            </Layout>
        </ThemeProvider>
    );
}

export default App;
